<template>
  <layouts>
    <template v-slot:content>
      <zloading v-if="loading"></zloading>
      <div v-else class="bg-gray-200 h-auto">
        <div class="container px-4 py-10 mx-auto max-w-7xl">
          <div class="flex items-start justify-between">
            <div>
              <h1 class="text-xl text-gray-800 font-medium mb-1">
                Ringkasan Omzet Luar Negri
              </h1>
              <h4 class="text-sm text-gray-500">
                Periode
                {{ stringDate(start_date) + " - " + stringDate(end_date) }}
              </h4>
            </div>
            <div class="flex items-center">
              <zdropdown
                text="Filter Transaksi"
                class="mr-4"
                v-if="profileData.type_user.includes('Super Admin')"
              >
                <template v-slot:item>
                  <div class="py-6 px-6">
                    <h4 class="text-sm font-medium mr-2 mb-1">
                      Rentang Tanggal:
                    </h4>
                    <zselect
                      class="mb-5"
                      v-model="filterDate"
                      :data="[
                        'Hari Ini',
                        'Bulan Ini',
                        'Tahun Ini',
                        '7 Hari Terakhir',
                        '30 Hari Terakhir',
                      ]"
                      placeholder="Pilih Periode"
                      @input="selectRangeDate"
                    >
                    </zselect>
                    <h1 class="font-medium mb-5">atau</h1>
                    <div class="flex items-center space-x-2">
                      <div class="w-1/2">
                        <h4 class="text-sm font-medium mr-2 mb-1">
                          Tanggal Mulai:
                        </h4>
                        <input
                          v-model="start_date"
                          class="w-full mr-5 rounded-md border-2 border-gray-300 focus:outline-none focus:border-blue-800 text-sm px-3 py-1.5"
                          type="date"
                        />
                      </div>
                      <div class="w-1/2">
                        <h4 class="text-sm font-medium mr-2 mb-1">
                          Tanggal Akhir:
                        </h4>
                        <input
                          v-model="end_date"
                          class="w-full rounded-md border-2 border-gray-300 focus:outline-none focus:border-blue-800 text-sm px-3 py-1.5"
                          type="date"
                        />
                      </div>
                    </div>
                    <div class="flex items-center">
                      <button
                        @click="
                          search = '';
                          filterDate = '';
                          start_date = '';
                          end_date = '';
                        "
                        class="mt-5 bg-blue-600 hover:bg-blue-700 px-4 py-2 text-semibold text-white rounded-md shadow"
                      >
                        Reset Filter
                      </button>
                    </div>
                  </div>
                </template>
              </zdropdown>
              <zselect
                class="mr-2 -mt-1 w-40"
                v-model="filterMonthly"
                :data="monthOptions"
                placeholder="Pilih Bulan"
              >
              </zselect>
              <zselect
                v-if="
                  profileData.role.access_permission.includes(
                    'dashboard-cabang'
                  ) && profileData.type_branch.length > 0
                "
                class="-mt-1 w-40"
                v-model="branchSelected"
                :data="branchOptions"
                placeholder="Pilih Cabang"
              ></zselect>

              <button
                @click="resetFilter"
                class="bg-blue-600 hover:bg-blue-700 px-4 py-2 text-semibold text-white rounded-md text-sm ml-2 focus:outline-none"
              >
                Reset Filter
              </button>
            </div>
          </div>
          <div class="flex item-center space-x-4 mt-5">
            <div
              class="lg:w-1/3 w-full bg-white  border border-blue-500 shadow-md rounded-md px-6 py-4 text-center"
            >
              <h6 class="text-base font-medium mb-2 text-sm">
                Omzet Real Bulan Ini
              </h6>
              <h6 class="text-lg font-semibold text-blue-800">
                Rp.
                {{
                  formatPrice(omzet_real_this_month ? omzet_real_this_month : 0)
                }}
              </h6>
              <span class="text-red-500"
                >-
                {{ formatPrice(omzet_piutang ? omzet_piutang : 0) }}
                (hutang)</span
              >
            </div>
            <div
              class="lg:w-1/3 w-full bg-white shadow-md border border-blue-500 rounded-md px-6 py-4 text-center"
            >
              <h4 class="text-base font-medium mb-2">Omzet Real Hari Ini</h4>
              <h1 class="text-xl font-semibold text-blue-800">
                Rp.
                {{
                  formatPrice(
                    total_omzet_real_today ? total_omzet_real_today : 0
                  )
                }}
              </h1>
            </div>
            <div
              class="lg:w-1/3 w-full bg-white shadow-md rounded-md px-6 py-4 text-center"
            >
              <h4 class="text-base font-medium mb-2">Omzet Bulan Ini</h4>
              <h1 class="text-xl font-semibold text-blue-800">
                Rp.
                {{
                  formatPrice(
                    total_omzet_this_month ? total_omzet_this_month : 0
                  )
                }}
              </h1>
            </div>

            <div
              class="lg:w-1/3 w-full bg-white shadow-md rounded-md px-6 py-4 text-center"
            >
              <h4 class="text-base font-medium mb-2">Omzet Hari Ini</h4>
              <h1 class="text-xl font-semibold text-blue-800">
                Rp.
                {{ formatPrice(total_omzet_today ? total_omzet_today : 0) }}
              </h1>
            </div>
          </div>
          <div class="flex item-center space-x-4 mt-5">
            <div
              class="lg:w-1/3 w-full bg-white shadow-md rounded-md px-6 py-4 text-center"
            >
              <h4 class="text-base font-medium mb-2">Omzet Bulanan</h4>
              <h1 class="text-xl font-semibold text-blue-800">
                Rp.
                {{
                  formatPrice(total_omzet_by_month ? total_omzet_by_month : 0)
                }}
              </h1>
              <span class="text-red-500"
                >-
                {{ formatPrice(totalPiutangMonth ? totalPiutangMonth : 0) }}
                (hutang)</span
              >
            </div>
            <div
              class="lg:w-1/3 w-full bg-white shadow-md rounded-md px-6 py-4 text-center"
            >
              <h4 class="text-base font-medium mb-2">Total Order Hari Ini</h4>
              <h1 class="text-xl font-semibold text-blue-800">
                {{ total_order_today }}
              </h1>
            </div>
            <div
              class="lg:w-1/3 w-full bg-white shadow-md rounded-md px-6 py-4 text-center"
            >
              <h4 class="text-base font-medium mb-2">Total Order Bulan Ini</h4>
              <h1 class="text-xl font-semibold text-blue-800">
                {{ total_order_this_month }}
              </h1>
            </div>
            <div
              class="lg:w-1/3 w-full bg-white shadow-md rounded-md px-6 py-4 text-center"
            >
              <h4 class="text-base font-medium mb-2">Total Berat Bulan Ini</h4>
              <h1 class="text-xl font-semibold text-blue-800">
                {{ total_weight_this_month.toFixed(2) }}kg
              </h1>
            </div>
          </div>
          <div class="mt-5 bg-white shadow rounded-md px-6 py-6">
            <h1 class="text-base text-gray-800 font-semibold mb-5">
              Statistik Order
            </h1>
            <div v-show="loading_order" class="animate-pulse flex space-x-4">
              <div class="flex-1 space-y-4 py-1">
                <div class="h-40 bg-gray-200 rounded w-full"></div>
              </div>
            </div>
            <line-chart
              v-if="loaded"
              :chartdata="order_statistics"
              :options="options"
            />
          </div>
          <div class="mt-5 bg-white shadow rounded-md px-6 py-6">
            <h1 class="text-base text-gray-800 font-semibold mb-5">
              Statistik Omzet
            </h1>
            <div v-show="loading_order" class="animate-pulse flex space-x-4">
              <div class="flex-1 space-y-4 py-1">
                <div class="h-40 bg-gray-200 rounded w-full"></div>
              </div>
            </div>
            <line-chart
              v-if="loaded_omzet"
              :chartdata="order_omzet"
              :options="options"
            />
          </div>
          <div class="mt-5 bg-white shadow rounded-md px-6 py-6">
            <h1 class="text-base text-gray-800 font-semibold mb-5">
              Statistik Transaksi Admin
            </h1>
            <div v-show="loading_admin" class="animate-pulse flex space-x-4">
              <div class="flex-1 space-y-4 py-1">
                <div class="h-40 bg-gray-200 rounded w-full"></div>
              </div>
            </div>
            <bar-chart
              v-if="load"
              :chartData="transactions_admin"
              :options="options"
            />
          </div>
          <!-- agen  -->
          <div class="mt-5 bg-white shadow rounded-md px-6 py-6">
            <h1 class="text-base text-gray-800 font-semibold mb-5">
              Statistik Transaksi Agen
            </h1>
            <div v-show="loading_admin" class="animate-pulse flex space-x-4">
              <div class="flex-1 space-y-4 py-1">
                <div class="h-40 bg-gray-200 rounded w-full"></div>
              </div>
            </div>
            <bar-chart
              v-if="loaded_agen"
              :chartData="transactions_agen"
              :options="options"
            />
          </div>
        </div>
      </div>
    </template>
  </layouts>
</template>

<script>
import layouts from "@/components/layouts";
import zdropdown from "@/components/zdropdown";
import zselect from "@/components/zselect";
import zloading from "@/components/zloading";
import LineChart from "@/components/zlinechart";
import BarChart from "../../components/BarChart.vue";

import { reactive, computed } from "@vue/composition-api";
import { useProfile } from "@/composables/auth/useAuth";
import { useBranches } from "@/composables/master/useMaster";
import {
  useOmzet,
  useOmzetReal,
  useStatisticOmzet,
  useOrderCount,
  useOrderStatistics,
  useWeight,
  useOrderTransactions,
  useOrderAgenTransactions,
} from "@/composables/report/useReport";

/* ===== Helpers murni di luar setup ===== */
function fmt(date) {
  const d = new Date(date);
  let m = "" + (d.getMonth() + 1);
  let day = "" + d.getDate();
  const y = d.getFullYear();
  if (m.length < 2) m = "0" + m;
  if (day.length < 2) day = "0" + day;
  return [y, m, day].join("-");
}
function readProfile() {
  try {
    return JSON.parse(window.localStorage.getItem("data-profile-jaskipin"));
  } catch (_) {
    return null;
  }
}
/* Branch resolver:
 *  - Super Admin / Supervisor → branchSelected.value (boleh undefined = all)
 *  - Admin Cabang             → tetap pakai profile.branch._id (terkunci ke
 *    cabangnya, walau di mode custom range). Sebelumnya allowAdminCabang
 *    membuat branch jadi undefined → BE balikkan semua cabang (kebocoran).
 *  - Role lain                → profile.branch._id
 *
 *  Param `allowAdminCabang` di-ignore agar Admin Cabang TIDAK PERNAH bisa
 *  melihat data cabang lain. */
function resolveBranch(profile, branchSelected /* , allowAdminCabang */) {
  if (!profile) return undefined;
  const t = profile.type_user;
  const elevated = t === "Super Admin" || t === "Supervisor";
  if (!elevated) {
    return profile.branch && profile.branch._id;
  }
  return branchSelected && branchSelected.value
    ? branchSelected.value
    : undefined;
}
function typeBranchParam(serverProfile) {
  if (!serverProfile) return undefined;
  /* fetchProfile() return body langsung. Fallback ke .data demi backward-compat. */
  const profile = serverProfile.data ? serverProfile.data : serverProfile;
  const tb = profile && profile.type_branch;
  if (!tb || !tb.length) return undefined;
  return tb.map((item) => item.value);
}

export default {
  components: {
    zselect,
    zdropdown,
    LineChart,
    zloading,
    BarChart,
    layouts,
  },
  setup() {
    /* Profile dari TanStack (cache 5 menit). */
    const { data: serverProfile } = useProfile();
    /* Master branch list (untuk Super Admin). */
    const { data: branchesData } = useBranches();

    const MONTH_LABELS = [
      "Januari", "Februari", "Maret", "April", "Mei", "Juni",
      "Juli", "Agustus", "September", "Oktober", "November", "Desember",
    ];
    const nowMonth = new Date().getMonth();
    const defaultMonthOption = {
      label: MONTH_LABELS[nowMonth],
      value: nowMonth,
    };

    /* UI state — drives reactive params. */
    const filterState = reactive({
      filterMonthly: defaultMonthOption,
      branchSelected: "",
      start_date: "",
      end_date: "",
      /* filterDate hanya untuk preset range, tidak ikut ke params. */
    });

    /* ========== Param computeds ========== */

    /* "Bulan ini" — first/last day current month + filter rule lama. */
    const paramsThisMonth = computed(() => {
      const now = new Date();
      const first = new Date(now.getFullYear(), now.getMonth(), 1);
      const last = new Date(now.getFullYear(), now.getMonth() + 1, 0);
      const profile = readProfile();
      const params = {
        start_date: fmt(first),
        end_date: fmt(last),
      };
      const tb = typeBranchParam(serverProfile.value);
      if (tb) params.type_branch = tb;
      params.branch = resolveBranch(profile, filterState.branchSelected, false);
      return params;
    });

    /* "Bulan ini" tapi memakai start_date/end_date jika user override —
       Admin Cabang juga dianggap elevated di branchnya. */
    const paramsThisMonthOrCustom = computed(() => {
      const profile = readProfile();
      const useCustom =
        !!filterState.start_date && !!filterState.end_date;
      let start_date;
      let end_date;
      if (useCustom) {
        start_date = filterState.start_date;
        end_date = filterState.end_date;
      } else {
        const now = new Date();
        start_date = fmt(new Date(now.getFullYear(), now.getMonth(), 1));
        end_date = fmt(new Date(now.getFullYear(), now.getMonth() + 1, 0));
      }
      const params = { start_date, end_date };
      const tb = typeBranchParam(serverProfile.value);
      if (tb) params.type_branch = tb;
      params.branch = resolveBranch(profile, filterState.branchSelected);
      return params;
    });

    /* "Hari ini" */
    const paramsToday = computed(() => {
      const today = fmt(new Date());
      const profile = readProfile();
      const params = {
        start_date: today,
        end_date: today,
      };
      const tb = typeBranchParam(serverProfile.value);
      if (tb) params.type_branch = tb;
      params.branch = resolveBranch(profile, filterState.branchSelected, false);
      return params;
    });

    /* "Pilih bulan" — enabled saat filterMonthly diset. */
    const paramsByMonth = computed(() => {
      if (!filterState.filterMonthly || filterState.filterMonthly === "") {
        return null;
      }
      const now = new Date();
      const v = filterState.filterMonthly.value;
      const first = new Date(now.getFullYear(), v, 1);
      const last = new Date(now.getFullYear(), parseInt(v + 1), 0);
      const profile = readProfile();
      const params = {
        start_date: fmt(first),
        end_date: fmt(last),
      };
      if (profile && profile.type_user === "Master Agen") {
        params.master_agen = profile.id;
        params.input_by = profile.id;
      }
      const tb = typeBranchParam(serverProfile.value);
      if (tb) params.type_branch = tb;
      params.branch = resolveBranch(profile, filterState.branchSelected, false);
      return params;
    });

    /* Chart statistik — pakai start_date/end_date custom. */
    const paramsStat = computed(() => {
      const profile = readProfile();
      const params = {
        start_date: filterState.start_date,
        end_date: filterState.end_date,
      };
      const tb = typeBranchParam(serverProfile.value);
      if (tb) params.type_branch = tb;
      params.branch = resolveBranch(profile, filterState.branchSelected, false);
      return params;
    });

    /* Admin & agen transactions — pakai today bila tidak ada custom range. */
    const paramsAdminTrx = computed(() => {
      const profile = readProfile();
      const useCustom =
        !!filterState.start_date && !!filterState.end_date;
      const today = fmt(new Date());
      const params = useCustom
        ? {
            start_date: filterState.start_date,
            end_date: filterState.end_date,
          }
        : { start_date: today, end_date: today };
      const tb = typeBranchParam(serverProfile.value);
      if (tb) params.type_branch = tb;
      params.branch = resolveBranch(profile, filterState.branchSelected, false);
      return params;
    });

    /* ========== Queries ========== */
    /* Omzet bulan ini (memperhatikan custom range) */
    const omzetThisMonthQ = useOmzet(paramsThisMonthOrCustom);
    /* Omzet real bulan ini (memperhatikan custom range juga) */
    const omzetRealThisMonthQ = useOmzetReal(paramsThisMonthOrCustom);
    /* Omzet hari ini */
    const omzetTodayQ = useOmzet(paramsToday);
    /* Omzet real hari ini */
    const omzetRealTodayQ = useOmzetReal(paramsToday);
    /* Omzet by month (filter dropdown) */
    const omzetByMonthQ = useOmzet(
      computed(() => paramsByMonth.value || {}),
      { enabled: computed(() => !!paramsByMonth.value) }
    );
    /* Order count today / this month */
    const orderTodayQ = useOrderCount(paramsToday);
    const orderThisMonthQ = useOrderCount(paramsThisMonth);
    /* Weight this month */
    const weightThisMonthQ = useWeight(paramsThisMonth);
    /* Order statistics chart */
    const orderStatisticsQ = useOrderStatistics(paramsStat, {
      enabled: computed(
        () => !!filterState.start_date && !!filterState.end_date
      ),
    });
    /* Omzet statistics chart */
    const omzetStatisticsQ = useStatisticOmzet(paramsStat, {
      enabled: computed(
        () => !!filterState.start_date && !!filterState.end_date
      ),
    });
    /* Transactions admin */
    const adminTrxQ = useOrderTransactions(paramsAdminTrx);
    /* Transactions agen */
    const agenTrxQ = useOrderAgenTransactions(paramsAdminTrx);

    return {
      serverProfile,
      branchesData,
      filterState,
      /* data refs */
      omzetThisMonthData: omzetThisMonthQ.data,
      omzetRealThisMonthData: omzetRealThisMonthQ.data,
      omzetTodayData: omzetTodayQ.data,
      omzetRealTodayData: omzetRealTodayQ.data,
      omzetByMonthData: omzetByMonthQ.data,
      orderTodayData: orderTodayQ.data,
      orderThisMonthData: orderThisMonthQ.data,
      weightThisMonthData: weightThisMonthQ.data,
      orderStatData: orderStatisticsQ.data,
      omzetStatData: omzetStatisticsQ.data,
      adminTrxData: adminTrxQ.data,
      agenTrxData: agenTrxQ.data,
      /* loading flag awal */
      omzetThisMonthLoading: omzetThisMonthQ.isLoading,
      orderStatLoading: orderStatisticsQ.isFetching,
      adminTrxLoading: adminTrxQ.isFetching,
    };
  },
  data() {
    return {
      filterDate: "",
      options: {
        scales: {
          yAxes: [
            {
              ticks: {
                beginAtZero: true,
              },
              gridLines: {
                display: true,
              },
            },
          ],
          xAxes: [
            {
              gridLines: {
                display: false,
              },
            },
          ],
        },
        legend: {
          display: true,
        },
        responsive: true,
        maintainAspectRatio: false,
      },
      monthOptions: [
        { label: "Januari", value: 0 },
        { label: "Februari", value: 1 },
        { label: "Maret", value: 2 },
        { label: "April", value: 3 },
        { label: "Mei", value: 4 },
        { label: "Juni", value: 5 },
        { label: "Juli", value: 6 },
        { label: "Agustus", value: 7 },
        { label: "September", value: 8 },
        { label: "Oktober", value: 9 },
        { label: "November", value: 10 },
        { label: "Desember", value: 11 },
      ],
    };
  },
  computed: {
    profileData() {
      let profile = JSON.parse(
        window.localStorage.getItem("data-profile-jaskipin")
      );
      return profile ? profile : null;
    },
    /* v-model proxies — keep template names */
    start_date: {
      get() {
        return this.filterState.start_date;
      },
      set(v) {
        this.filterState.start_date = v;
      },
    },
    end_date: {
      get() {
        return this.filterState.end_date;
      },
      set(v) {
        this.filterState.end_date = v;
      },
    },
    filterMonthly: {
      get() {
        return this.filterState.filterMonthly;
      },
      set(v) {
        this.filterState.filterMonthly = v;
      },
    },
    branchSelected: {
      get() {
        return this.filterState.branchSelected;
      },
      set(v) {
        this.filterState.branchSelected = v;
      },
    },
    branchOptions() {
      const profile = this.profileData;
      if (profile && profile.type_user === "Super Admin") {
        const raw = this.branchesData;
        const arr = Array.isArray(raw)
          ? raw
          : raw && raw.data
          ? raw.data
          : [];
        return arr.map((item) => ({
          label: item.city_name,
          value: item.id,
        }));
      }
      /* Non super admin — pakai type_branch dari serverProfile */
      const sp = this.serverProfile;
      const tb = sp && sp.data && sp.data.type_branch ? sp.data.type_branch : [];
      return tb.map((item) => ({
        label: item.label,
        value: item.value,
      }));
    },
    /* ===== Data mappings ===== */
    total_omzet_this_month() {
      const arr = this._dataArray(this.omzetThisMonthData);
      return arr.length === 0 ? 0 : arr[0].amount_paid;
    },
    omzet_real_this_month() {
      const arr = this._dataArray(this.omzetRealThisMonthData);
      return arr.length === 0 ? 0 : arr[0].cash + arr[0].transfer;
    },
    omzet_piutang() {
      const arr = this._dataArray(this.omzetRealThisMonthData);
      if (arr.length === 0) return 0;
      return arr[0].amount_paid - arr[0].cash - arr[0].transfer;
    },
    total_omzet_today() {
      const arr = this._dataArray(this.omzetTodayData);
      return arr.length === 0 ? 0 : arr[0].amount_paid;
    },
    total_omzet_real_today() {
      const arr = this._dataArray(this.omzetRealTodayData);
      return arr.length === 0 ? 0 : arr[0].cash + arr[0].transfer;
    },
    total_omzet_by_month() {
      if (!this.filterState.filterMonthly) return 0;
      const arr = this._dataArray(this.omzetByMonthData);
      return arr.length === 0 ? 0 : arr[0].amount_paid;
    },
    totalPiutangMonth() {
      if (!this.filterState.filterMonthly) return 0;
      const arr = this._dataArray(this.omzetByMonthData);
      if (arr.length === 0) return 0;
      return (
        arr[0].amount_paid - arr[0].total_paid_cash - arr[0].total_paid_transfer
      );
    },
    total_order_today() {
      const arr = this._dataArray(this.orderTodayData);
      return arr.length === 0 ? 0 : arr[0].count;
    },
    total_order_this_month() {
      const arr = this._dataArray(this.orderThisMonthData);
      return arr.length === 0 ? 0 : arr[0].count;
    },
    total_weight_this_month() {
      const arr = this._dataArray(this.weightThisMonthData);
      return arr.length === 0 ? 0 : arr[0].charge_weight;
    },
    order_statistics() {
      const arr = this._dataArray(this.orderStatData);
      if (!arr.length) return null;
      return {
        labels: arr.map((item) => item.date),
        datasets: [
          {
            label: "Total Order",
            borderColor: "rgba(50, 115, 220, 0.5)",
            backgroundColor: "rgba(50, 115, 220, 0.1)",
            data: arr.map((item) => item.order_count),
          },
        ],
      };
    },
    order_omzet() {
      const arr = this._dataArray(this.omzetStatData);
      if (!arr.length) return null;
      return {
        labels: arr.map((item) => item.date),
        datasets: [
          {
            label: "Total Omzet",
            borderColor: "rgba(255, 99, 132,1)",
            backgroundColor: "rgba(255, 99, 132, 0.2)",
            data: arr.map((item) => item.omzet),
          },
        ],
      };
    },
    transactions_admin() {
      const arr = this._dataArray(this.adminTrxData);
      if (!arr.length) return null;
      return {
        labels: arr.map((item) => item.pengguna),
        datasets: [
          {
            label: "Total Transaksi Admin",
            borderWidth: 1,
            borderColor: "rgba(50, 115, 220, 0.5)",
            backgroundColor: "rgba(50, 115, 220, 0.2)",
            pointBorderColor: "#2554FF",
            data: arr.map((item) => item.total),
          },
        ],
      };
    },
    transactions_agen() {
      const arr = this._dataArray(this.agenTrxData);
      if (!arr.length) return null;
      return {
        labels: arr.map((item) => item.pengguna),
        datasets: [
          {
            label: "Total Transaksi Agen",
            borderWidth: 1,
            borderColor: "rgba(255,99,132,1)",
            backgroundColor: "rgba(255, 99, 132, 0.2)",
            pointBorderColor: "#2554FF",
            data: arr.map((item) => item.total),
          },
        ],
      };
    },
    loaded() {
      return !!this.order_statistics;
    },
    loaded_omzet() {
      return !!this.order_omzet;
    },
    load() {
      return !!this.transactions_admin;
    },
    loaded_agen() {
      return !!this.transactions_agen;
    },
    loading_order() {
      return this.orderStatLoading;
    },
    loading_admin() {
      return this.adminTrxLoading;
    },
    loading() {
      return this.omzetThisMonthLoading && !this.omzetThisMonthData;
    },
  },
  created() {
    this.selectRangeDate();
  },
  methods: {
    _dataArray(raw) {
      if (!raw) return [];
      if (Array.isArray(raw)) return raw;
      if (raw.data) return Array.isArray(raw.data) ? raw.data : [];
      return [];
    },
    resetFilter() {
      this.filterDate = "Bulan Ini";
      this.filterState.start_date = "";
      this.filterState.end_date = "";
      const nowMonth = new Date().getMonth();
      this.filterState.filterMonthly =
        this.monthOptions.find((m) => m.value === nowMonth) || "";
      this.filterState.branchSelected = "";
      this.selectRangeDate();
    },
    selectRangeDate() {
      let date = new Date();
      let firstDay;
      let lastDay;

      switch (this.filterDate) {
        case "Hari Ini":
          firstDay = date;
          lastDay = date;
          break;

        case "Bulan Ini":
          firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
          lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
          break;

        case "Tahun Ini":
          firstDay = new Date(date.getFullYear(), 0, 1);
          lastDay = new Date(date.getFullYear(), 11, 31);
          break;

        case "7 Hari Terakhir":
          firstDay = new Date(date.setDate(date.getDate() - 7));
          lastDay = new Date();
          break;

        case "30 Hari Terakhir":
          firstDay = new Date(date.setDate(date.getDate() - 30));
          lastDay = new Date();
          break;

        default:
          firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
          lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
          break;
      }

      this.filterState.start_date = this.formatDate(firstDay);
      this.filterState.end_date = this.formatDate(lastDay);
    },
    formatDate(date) {
      return fmt(date);
    },
    stringDate(value) {
      let options = { year: "numeric", month: "long", day: "numeric" };
      let date = new Date(value).toLocaleString("id-ID", options);
      return date;
    },
    formatPrice(number) {
      var rupiah = "";
      var angkarev = number
        .toString()
        .split("")
        .reverse()
        .join("");
      for (var i = 0; i < angkarev.length; i++)
        if (i % 3 == 0) rupiah += angkarev.substr(i, 3) + ".";
      return rupiah
        .split("", rupiah.length - 1)
        .reverse()
        .join("");
    },
  },
};
</script>

<style scoped></style>
